import React, { Component } from 'react';
import Link from '../common/TrackedLink';
import LazyLoad from 'react-lazyload';
import classnames from 'classnames';
import { pushCardCtaItem, pushCtaItem, pushEcommerceEvent } from "../../utils/datalayer";

class ProductCard extends Component {
	constructor(props) {
		super(props);
		this.state = ({
			checked: false
		});
	}

	addToCompare(event) {
		this.props.addToCompare(event);
		if (this.state.checked === true) {
			this.setState({
				checked: false
			});
		} else {
			this.setState({
				checked: true
			});
		}
		// global.dataLayer.push({
		// 	event: 'Product Tile',
		// 	eventCategory: 'Product Tiles',
		// 	eventAction: 'Compare',
		// 	eventLabel: `${this.props.product.name} - Model ${this.props.product.modelNumber}`
		// });
	}

	handleClickCompare() {
		this.props.clickCompare();
	}

	handleClick(event) {
		const productAsArray = [this.props.product];
		//console.log(productAsArray, typeof productAsArray);
		pushEcommerceEvent('select_item', productAsArray, this.props.category);
	}

	handleBuyNowClick(event) {
		event.stopPropagation();
		pushCtaItem(event, `ctaBuyNowFor_${this.props.product.modelNumber}`);
	}

	render() {

		const { bestOfBest, tile, manualLink, name, modelNumber, image, hoverImage, priceBucket, checked, onSale, directToConsumer, directToConsumerUrl, ecommercePrice, originalPrice } = this.props.product;
		const cardStyles = classnames('product-detail col sm-4', {
			'best': bestOfBest
		});
		let showSaleFlag = false;
		if (ecommercePrice !== undefined && originalPrice !== undefined) {
			if (originalPrice > ecommercePrice) {
				showSaleFlag = true;
			}
		}

		// if (showSaleFlag === true) {
		// 	console.log(modelNumber + ' is ON SALE');
		// 	console.log("ecommercePrice: " + ecommercePrice);
		// 	console.log("originalPrice: " + originalPrice);
		// }
		let displayPrice = priceBucket;
		if (directToConsumer && directToConsumerUrl) {
			displayPrice = '$' + ecommercePrice;
		}

		let productTile;
		if (tile) {
			productTile = (
				<Link
					className="results-callout"
					to={manualLink}
					onClick={(e) => { this.handleClick(e) }}
				>
					<div>
						<h3 className="title">
							{name}
						</h3>
						<p>{modelNumber}</p>
						<span className="arrow-link">
							{image}
						</span>
					</div>
				</Link >
			);
		} else {
			productTile = (
				<div className="product-info flex-grow-1">
					<Link
						to={`/product/${modelNumber}`}
						onClick={(e) => { this.handleClick(e) }}
					>
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={image}
									alt={`Model ${modelNumber}`}
								/>
							</LazyLoad>
							{
								hoverImage !== undefined ?
									(
										<LazyLoad once={true} offset={200}>
											<img
												src={hoverImage}
												alt={`Model ${modelNumber}`}
											/>
										</LazyLoad>
									) : null
							}
						</div>
						<h3 className="name">
							{name}
							<span className="assistive-text"> &ndash;</span>
							<span className="model"> Model {modelNumber}</span>
						</h3>
					</Link>
					<div style={{ textAlign: "left" }}>
						<div data-bv-show="inline_rating" data-bv-product-id={modelNumber}></div>
					</div>
					<div className={`flex-grow-1 mt-auto`}>
						{directToConsumerUrl &&
							<div className={`my-3`}>
								<Link to={directToConsumerUrl} className={`btn btn-outline-dark btn-sm`} target='_blank' onClick={(e) => { this.handleBuyNowClick(e) }}>Buy
									Now</Link>
							</div>
						}
						<div className={`d-flex justify-content-between align-items-center`}>
							<p className="price">
								{displayPrice}
							</p>
							<div className="compare">
								<input
									type="checkbox"
									id={`compare${modelNumber}`}
									value={modelNumber}
									checked={checked}
									onChange={() => this.addToCompare(modelNumber)}
								/>
								<label
									htmlFor={`compare${modelNumber}`}
									className={this.state.checked ? 'assistive-text' : 'active'}
								>
									Check to Compare
								</label>
								<a
									onClick={() => this.handleClickCompare()}
									className={this.state.checked ? 'active' : 'hide'}
								>
									Compare
								</a>
							</div>
						</div>
					</div>
				</div>
			);
		}

		let stack;
		stack = (
			<div className="flags">
				{bestOfBest &&
					<span className="flag flag-red">
						<span className="flag-text">Best Seller</span>
					</span>
				}
				{showSaleFlag &&
					<span className="flag flag-yellow">
						<span className="flag-text">Sale</span>
					</span>
				}
			</div>
		);

		return (
			<li className={cardStyles}>
				{stack}
				{productTile}
			</li>
		);
	}
};

export default ProductCard;


// WEBPACK FOOTER //
// ./src/pages/productSearch/ProductCard.js